const STAGES = [
  {
    n: "01",
    title: "Recepción documental",
    desc: "[Etapa 1 — descripción breve del cotejo inicial de documentos del vehículo, sin trámite en línea.]",
  },
  {
    n: "02",
    title: "Investigación legal vehicular",
    desc: "[Etapa 2 — descripción de la revisión de historial legal, robo, adeudos y verificaciones.]",
  },
  {
    n: "03",
    title: "Revisión mecánica y estructural",
    desc: "[Etapa 3 — descripción de la inspección mecánica, estructural y de sistemas.]",
  },
  {
    n: "04",
    title: "Entrega controlada",
    desc: "[Etapa 4 — descripción del proceso de entrega al comprador con expediente cerrado.]",
  },
];

export default function ProcessDiagram() {
  return (
    <section id="proceso" className="bg-white py-24 md:py-32" data-testid="section-proceso">
      <div className="container-x">
        <div className="mb-16 max-w-2xl">
          <p className="mono text-xs uppercase tracking-widest text-[#A0553F]">Proceso de certificación</p>
          <h2 className="mt-3 font-serif text-4xl leading-[1.05] text-[#3E5641] md:text-5xl">
            Cuatro etapas antes de que un auto se exhiba.
          </h2>
          <p className="mt-5 max-w-xl text-[#6B7678]">
            Cada unidad pasa por un flujo secuencial. Si falla una etapa, no avanza a la siguiente. Sin excepciones.
          </p>
        </div>

        {/* Desktop connected diagram */}
        <div className="relative hidden md:block">
          <div className="grid grid-cols-4 gap-0">
            {STAGES.map((s, i) => (
              <div key={s.n} className="relative">
                {/* connector line except last */}
                {i < STAGES.length - 1 && (
                  <div className="stage-dashline absolute right-0 top-[27px] h-px w-[calc(100%-56px)] translate-x-[28px]" />
                )}
                <div className="flex flex-col pr-8">
                  <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-[#3E5641] bg-white">
                    <span className="mono text-sm text-[#3E5641]">{s.n}</span>
                  </div>
                  <h3 className="mt-6 font-serif text-xl text-[#3E5641]">{s.title}</h3>
                  <p className="mt-3 max-w-[240px] text-sm leading-relaxed text-[#6B7678]">
                    {s.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile vertical */}
        <div className="md:hidden">
          {STAGES.map((s, i) => (
            <div key={s.n} className="relative flex gap-4 pb-10">
              {i < STAGES.length - 1 && (
                <div className="stage-dashline-vert absolute left-[27px] top-14 bottom-0 w-px" />
              )}
              <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border border-[#3E5641] bg-white">
                <span className="mono text-sm text-[#3E5641]">{s.n}</span>
              </div>
              <div>
                <h3 className="font-serif text-xl text-[#3E5641]">{s.title}</h3>
                <p className="mt-2 text-sm text-[#6B7678]">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
